/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Plan_RequiredInputs */



/**
* | output |
* | --- |
* | "The ElevenLabs integration is available on Pro and Enterprise plans." |
*
* @param {Voice_Manager_Elevenlabs_Plan_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_plan_required = /** @type {((inputs?: Voice_Manager_Elevenlabs_Plan_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Plan_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L’intégration ElevenLabs est disponible avec les forfaits Pro et Enterprise.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die ElevenLabs-Integration ist in den Tarifen Pro und Enterprise verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L’integrazione con ElevenLabs è disponibile nei piani Pro ed Enterprise.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Интеграция с ElevenLabs доступна в тарифах Pro и Enterprise.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La integración con ElevenLabs está disponible en los planes Pro y Enterprise.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ElevenLabs 集成适用于 Pro 和 Enterprise 套餐。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs 連携は Pro プランと Enterprise プランで利用できます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ElevenLabs एकीकरण Pro और Enterprise प्लान में उपलब्ध है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A integração com a ElevenLabs está disponível nos planos Pro e Enterprise.")
	return /** @type {LocalizedString} */ ("The ElevenLabs integration is available on Pro and Enterprise plans.")
});